import { Box, Fade, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'

export const RealXTagline = ({color = "#111"}) => {
    const words = ['Assets','Investments','Returns']
    const [index, setIndex] = useState(0);
    const [visible, setVisible] = useState(true);
   
     useEffect(() => {
       const interval = setInterval(() => {
         setVisible(false);
         setTimeout(() => {
           setIndex((prev) => (prev + 1) % words.length);
           setVisible(true);
         }, 1000); 
       }, 2300); 
   
       return () => clearInterval(interval);
     }, []);
   
     return (
       <Box display="flex" alignItems="center" gap={0.7}>
         <Typography variant="body2" sx={{color:color}}>Real</Typography>
         <Fade in={visible} timeout={1000}>
           <Typography sx={{color:'#e21a1a'}} variant="body2" key={index}> 
             {words[index]}
           </Typography>
         </Fade>
       </Box>
     );
}
